import { render } from "./JsonField.vue?vue&type=template&id=4ed8dd93"
import script from "./JsonField.vue?vue&type=script&lang=js"
export * from "./JsonField.vue?vue&type=script&lang=js"

import "./JsonField.vue?vue&type=style&index=0&id=4ed8dd93&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__